import React from 'react';
import util from 'Utils/commonUtil'

class Input extends React.Component {
    state = {
        value: ''
    };

    createdInput = element => {
        if(!element) return;

        if(this.props.loadedFocus) element.focus();
    }

    getOtherProps = () => {
        let otherProps = { ...this.props };

        delete otherProps.value;
        delete otherProps.onChange;
        delete otherProps.title;
        delete otherProps.className;
        delete otherProps.loadedFocus;

        return otherProps;
    }

    onChange = ev => {
        if(!util.isString(this.props.value)) {
            this.setState({ value: ev.target.value });
        }

        if(util.isFunction(this.props.onChange)) {
            this.props.onChange(this.props.title, ev.target.value, ev);
        }
    }

    render() {
        const value = util.isString(this.props.value) ? this.props.value : this.state.value;
        let classNameList = ['common-input'];
        if(util.isString(this.props.className)) {
            classNameList = ['common-input', ...this.props.className.split(' ')];
        }

        return (
            <div className={ classNameList.join(' ') } style={ this.props.style }>
                <input ref={ this.createdInput } value={ value } { ...this.getOtherProps() } onChange={ this.onChange } />
            </div>
        );
    }
}

export default Input;
